import React from 'react';
function readVariant(storageKey, variants) {
    const fallback = variants[0];
    if (typeof window === 'undefined')
        return fallback;
    try {
        const existing = localStorage.getItem(storageKey);
        if (existing && variants.includes(existing))
            return existing;
        const next = variants[Math.floor(Math.random() * variants.length)] ?? fallback;
        localStorage.setItem(storageKey, next);
        return next;
    }
    catch {
        return fallback;
    }
}
export function useExperimentVariant(exp, variants, registryBase, siteKey) {
    if (variants.length === 0)
        throw new Error('useExperimentVariant requires at least one variant');
    const storageKey = React.useMemo(() => `cmp.exp.${exp}.variant`, [exp]);
    const list = React.useMemo(() => [...variants], [variants]);
    const [variant, setVariantState] = React.useState(() => readVariant(storageKey, list));
    React.useEffect(() => {
        setVariantState((current) => {
            const resolved = readVariant(storageKey, list);
            if (resolved === current)
                return current;
            return resolved;
        });
    }, [storageKey, list]);
    // fire-and-forget exposure event once per change
    React.useEffect(() => {
        if (!registryBase)
            return;
        const url = new URL('/api/admin/analytics/experiments/event', registryBase);
        fetch(url.toString(), {
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify({ exp, variant, event: 'view', siteKey }),
        }).catch(() => undefined);
    }, [exp, variant, registryBase, siteKey]);
    const setVariant = React.useCallback((next) => {
        if (!list.includes(next))
            return;
        try {
            if (typeof window !== 'undefined')
                localStorage.setItem(storageKey, next);
        }
        catch {
            /* ignore persistence errors */
        }
        setVariantState(next);
    }, [list, storageKey]);
    const emit = React.useCallback((event) => {
        if (!registryBase)
            return;
        const url = new URL('/api/admin/analytics/experiments/event', registryBase);
        fetch(url.toString(), {
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify({ exp, variant, event, siteKey }),
        }).catch(() => undefined);
    }, [exp, variant, registryBase, siteKey]);
    return { variant, emit, setVariant };
}
//# sourceMappingURL=experiment.js.map